module.exports = __webpack_public_path__ + "img/logo.b3acb619.png";